export function getPackageName(code) {
    switch (code) {
        case "001":
            return 'Υπηρεσία Energy Check up';
        case "002":
            return 'Υπηρεσία Συντήρησης Λέβητα Φυσικού Αερίου';
        case "003":
            return 'Πιστοποιητικό Ενεργειακής Απόδοσης (Π.Ε.Α.)';
        case "004":
            return 'Υ.Δ.Ε. Ηλεκτρολογικής Εγκατάστασης';
        case "011":
            return 'Υ.Δ.Ε. Ηλεκτρολογικής Εγκατάστασης 2022';
        default:
            return "Άγνωστη υπηρεσία"
    }
}